import React from "react";
import { logError } from "../utils/logError";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError(error, {
      type: "react.errorBoundary",
      componentStack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: 24,
            fontFamily: "system-ui, sans-serif",
            maxWidth: 480,
            margin: "10vh auto",
          }}
        >
          <h1 style={{ fontSize: "1.25rem", marginBottom: 16 }}>
            {this.props.t("Es ist ein unerwarteter Fehler aufgetreten.")}
          </h1>
          <p style={{ marginBottom: 24, color: "#444" }}>
            {this.props.t(
              "Bitte laden Sie die Seite neu. Wenn das Problem bleibt, wenden Sie sich an den Support."
            )}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 18px",
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            {this.props.t("Seite neu laden")}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
